// import { useEffect, useRef, useState } from 'react'
// import { useFormik } from "formik";
// import { Helmet } from "react-helmet";
// import axios from "./../../helper/axios";
// import { useHistory } from 'react-router-dom';
// //for date picker calender need to import all tha files
// import { DateRangePicker } from 'react-date-range'
// import format from 'date-fns/format'
// import { addDays } from 'date-fns'
// import { subDays } from 'date-fns'
// import 'react-date-range/dist/styles.css'
// import 'react-date-range/dist/theme/default.css'
// import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';
// import { GrDocumentDownload } from "react-icons/gr";
// import {FaFileDownload } from "react-icons/fa";
// import Apointmentsearch from '../../Component/Apointmentsearch';
// import { useUser } from '../../Provider';
// import HospitalCodeSearch from '../../Component/HospitalCodeSearch';

// // import ReactHtmlTableToExcel from 'react-html-table-to-excel'
// //Each property is assigned an empty string as its initial value for this form field value
// const initialValues = {
//   opdnumber: "",
//   opdtype:"",
//   hospitalcode:""

//   };
// const AppointmentReport = () => {
//     //     The useHistory hook is typically used in a functional component within
//   //      a React application to access the browser's history object and manipulate the browser's URL programmatically.
//   // //**the history object to navigate the user to a different route by calling  return history.push('/'); */
//   const history = useHistory();
//   const {user, userHospitalcode, userrole1, isAuthRole,isAuthorized,gettokenId,token  } = useUser();
//   const [searchValue, setSearchValue] = useState("");
//   //OPD Number search
//   const handleSearchChange = (searchTerm) => {
//     console.log(searchTerm)
//     setSearchValue(searchTerm); // Update the searchValue state with the search term
//   };
//   //Hospitalcode search
//   const onSearchItems = (searchTerm) => {
//     console.log("------",searchTerm)
//     setValues({
//       ...values,
//       hospitalcode: searchTerm.hospitalcode,
//       // Update other fields as needed
//     });
//   };
//   const { values, errors, touched, handleBlur, handleChange, handleReset, handleSubmit,setValues } =
//     useFormik({
//       initialValues,
//       onSubmit: async (values, action,) => {
//         try {
//           if (userHospitalcode !== undefined && userrole1 !== undefined) {

//           const startDate = range[0].startDate;
//           const endDate = range[0].endDate;
//           const timezoneOffset = startDate.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
//           const adjustedDate = new Date(startDate.getTime() - timezoneOffset);
//           const adjustedDates = new Date(endDate.getTime() - timezoneOffset);
//           console.log(adjustedDate.toISOString().slice(0, 10));
//           //when i directlly used range[0].startDate.toISOString().slice(0, 10) the output was yesterday date so I used
//           //adjustedDate.toISOString().slice(0, 10) to get start date
//           const data = new FormData();
//           data.append("document", JSON.stringify(values));
//           data.append("searchValue", JSON.stringify(searchValue));
//           data.append("startDate", adjustedDate.toISOString().slice(0, 10)); // Add start date
//           data.append("endDate", adjustedDates.toISOString().slice(0, 10)); // Add end date
//           const response = await axios.post("/appointmentpost", data, {
//             //send token header to authorize the api
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "multipart/form-data",
//             },
//             params: {
//               hospitalcodes: userHospitalcode, // Include the hospitalcode in the query parameters
//               userrole: userrole1, // Include the userrole in the query parameters
//             },
//           });
//           if (response.data.length === 0) {
//             // If the response data is an empty array, display a message
//             alert("No data found");
//             setDataSupply(response.data);
//           } else {
//             // Otherwise, set the dataSupply state with the response data
//             console.log(response.data);
//             setDataSupply(response.data);
//           }
//           }
//         } catch (err) {

//         }
//         action.resetForm();
//       },

//     });
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [dataSupply, setDataSupply] = useState([]);

//   useEffect(() => {
//    // loadHospitalcode();
//     if (!localStorage.getItem('jwtToken')) {
//       return history.push('/');

//     }
//      // Calculate total price
// // It will recalculate the total price whenever there's a change in the dataSupply array.
// // The reduce method is called on the dataSupply array. The reduce method iterates over each item in the array and
// //accumulates the total price. The initial value for the accumulator is set to 0.
// // For each item in the dataSupply array, the amount property is accessed and parsed as an float using parseFloat.
// // The parsed value is then added to the accumulator.
// // Finally, the totalPrice is set to the calculated value using the setTotalPrice function, which updates the state variable totalPrice.
//     const totalPrice = dataSupply.reduce((total, item) => total + parseFloat(item.amount), 0);
//     setTotalPrice(totalPrice);
//   }, [dataSupply], []);

//   // date state
//   const [range, setRange] = useState([
//     {
//       endDate: new Date(),
//       startDate: subDays(new Date(), 7),
//       key: 'selection'
//     }
//   ])
//   console.log(range)
//   // open close
//   const [open, setOpen] = useState(false)
//   // get the target element to toggle
//   const refOne = useRef(null)
//   useEffect(() => {
//     // event listeners
//     document.addEventListener("keydown", hideOnEscape, true)
//     document.addEventListener("click", hideOnClickOutside, true)
//   }, [])
//   // hide dropdown on ESC press
//   const hideOnEscape = (e) => {
//     // console.log(e.key)
//     if (e.key === "Escape") {
//       setOpen(false)
//     }
//   }
//   // Hide dropdown on outside click
//   const hideOnClickOutside = (e) => {
//     if (refOne.current && !refOne.current.contains(e.target)) {
//       setOpen(false)
//     }
//   }
//   //function is for downloding the table data
//   const handleDownload = (event) => {
//     event.preventDefault();
//     // Create a new workbook and worksheet
//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.table_to_sheet(document.getElementById('supplyitem'));//need to provide the id of specific table here (id is supplyitem) .

//     // Add the worksheet to the workbook
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

//     // Convert the workbook to an Excel file
//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

//     // Save the file using FileSaver.js
//     const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//     saveAs(data, 'Appointment_report.xlsx');
//   };
//   const currentDomain = window.location.hostname;
//   return (
//     <div>
// <Helmet>
//         <title>Appointment Report | {currentDomain} | Hospital Management Software | Smart Solutions for Hospital Efficiency</title>
//       </Helmet>
//       <div className="">
//         <form onSubmit={handleSubmit}>
//           <div className="input-employeecontainer">
//           <div className="input-blockemployee">
//               <label htmlFor="date" className="input-labelemployee">
//                 Created on
//               </label>
//               <div className="calendarWrap">
//                 <input
//                   type="text"
//                   name="date"
//                   id="date"
//                   value={`${format(range[0].startDate, "dd/MM/yyyy")} to ${format(range[0].endDate, "dd/MM/yyyy")}`}
//                   readOnly
//                   onClick={() => setOpen(open => !open)}
//                 />
//                 <div ref={refOne}>
//                   {open &&
//                     <DateRangePicker
//                       onChange={item => setRange([item.selection])}
//                       editableDateInputs={true}
//                       moveRangeOnFirstSelection={false}
//                       ranges={range}
//                       months={1}
//                       direction="vertical"
//                       className="calendarElement"
//                     />
//                   }
//                 </div>
//               </div>
//             </div>

//             <div className="input-blockemployee">
//               <label htmlFor="opdtype" className="input-labelemployee">
//                OPD type
//               </label>
//               <div className="inputerroremployee">
//                 <select
//                   type="text"
//                   autoComplete="off"
//                   name="opdtype"
//                   id="opdtype"
//                   value={values.opdtype}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                  <option>Select OPD type</option>
//                  <option>New</option>
//                  <option>Visit</option>
//                 </select>
//               </div>
//             </div>
//           </div>
//           <div className="input-employeecontainer">
//           <div className="input-blockemployee">
//               <label htmlFor="idforrequisition" className="input-labelemployee">
//                OPD Number
//               </label>
//               <div className="inputerroremployee">
//                 {/* <input
//                   type="text"
//                   autoComplete="off"
//                   name="idforrequisition"
//                   id="idforrequisition"
//                   value={values.idforrequisition}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >

//                 </input> */}
//                  <Apointmentsearch onSearchChange={handleSearchChange} />
//               </div>
//             </div>
//             {isAuthorized ? (  <div className="input-blockemployee">
//               <label htmlFor="hospitalcode" className="input-labelemployee">
//                Hospital code
//               </label>
//                 <div className="inputerroremployee">
//                 <HospitalCodeSearch onSearchItem={onSearchItems} />
//                 {/* <select
//                   type="text"
//                   autoComplete="off"
//                   name="hospitalcode"
//                   id="hospitalcode"
//                   value={values.hospitalcode}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                   <option>Select Hospitalcode </option>
//                   {data.map(data => (
//                     <option value={data.hospitalcode} key={data.Id} >{data.hospitalcode}</option>
//                   ))
//                   }
//                 </select> */}
//               </div>
//             </div> ) : null}
//           </div>

//           <div className='buttonDisplay'>
//             <button className="allbuttonget">Get Details</button>
//             <FaFileDownload className='download' onClick={handleDownload}/>
//           </div>
//           <br />
//           <div className='container2'>
//             <table id="supplyitem">
//               <thead>
//                 <tr>
//                   <th>OPD Number</th>
//                   <th>Patient Id</th>
//                   <th>OPD Type </th>
//                   <th>Full Name</th>
//                   <th>Mobile No</th>
//                   <th>Appointment Time</th>
//                   <th>Created On</th>
//                   <th>Doctor</th>
//                   {isAuthorized ? (   <th>Hospital Code</th>) : null}
//                   {/* <th>Months</th>
//                   <th>Years</th>  */}
//                 </tr>
//               </thead>

//               <tbody>
//                 {
//                   dataSupply.map((value, key) => {
//                     return (
//                       <tr key={key}>
//                            <td>{value.opdnumber}</td>
//                            <td>{value.patientid}</td>
//                            <td>{value.opdtype}</td>
//                            <td>{value.patientname}</td>
//                            <td>{value.phoneno}</td>
//                            <td>{value.appointmentdate}</td>
//                            <td>{value.createdon}</td>
//                            <td>{value.fname}</td>
//                            {isAuthorized ? (<td>{value.hospitalcode}</td>) : null}
//                            {/* <td>{value.opdnumber}</td>
//                            <td>{value.opdnumber}</td> */}
//                       </tr>
//                     )
//                   })
//                 }
//               </tbody>
//             </table>
//           </div>
//         </form>
//       </div>
//     </div>
//   )
// }

// export default AppointmentReport

// import { useEffect, useRef, useState } from "react";
// import { useFormik } from "formik";
// import { Helmet } from "react-helmet";
// import axios from "./../../helper/axios";
// import { useHistory } from "react-router-dom";
// import { DateRangePicker } from "react-date-range";
// import format from "date-fns/format";
// import { addDays } from "date-fns";
// import { subDays } from "date-fns";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import { GrDocumentDownload } from "react-icons/gr";
// import { FaFileDownload } from "react-icons/fa";
// import Apointmentsearch from "../../Component/Apointmentsearch";
// import { useUser } from "../../Provider";
// import HospitalCodeSearch from "../../Component/HospitalCodeSearch";
// import { useToast } from "../ToastSystem";

// const initialValues = {
//   opdnumber: "",
//   opdtype: "",
//   hospitalcode: "",
// };

// const AppointmentReport = () => {
//   const history = useHistory();
//   const {
//     user,
//     userHospitalcode,
//     userrole1,
//     isAuthRole,
//     isAuthorized,
//     gettokenId,
//     token,
//   } = useUser();
//   const { showSuccess, showError, showInfo } = useToast();

//   const [searchValue, setSearchValue] = useState("");
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [dataSupply, setDataSupply] = useState([]);
//   const [range, setRange] = useState([
//     {
//       endDate: new Date(),
//       startDate: subDays(new Date(), 7),
//       key: "selection",
//     },
//   ]);
//   const [open, setOpen] = useState(false);
//   const refOne = useRef(null);

//   const handleSearchChange = (searchTerm) => {
//     console.log(searchTerm);
//     setSearchValue(searchTerm);
//   };

//   const onSearchItems = (searchTerm) => {
//     console.log("------", searchTerm);
//     setValues({
//       ...values,
//       hospitalcode: searchTerm.hospitalcode,
//     });
//   };

//   const {
//     values,
//     errors,
//     touched,
//     handleBlur,
//     handleChange,
//     handleReset,
//     handleSubmit,
//     setValues,
//   } = useFormik({
//     initialValues,
//     onSubmit: async (values, action) => {
//       try {
//         if (userHospitalcode !== undefined && userrole1 !== undefined) {
//           const startDate = range[0].startDate;
//           const endDate = range[0].endDate;
//           const timezoneOffset = startDate.getTimezoneOffset() * 60000;
//           const adjustedDate = new Date(startDate.getTime() - timezoneOffset);
//           const adjustedDates = new Date(endDate.getTime() - timezoneOffset);
//           console.log(adjustedDate.toISOString().slice(0, 10));

//           const data = new FormData();
//           data.append("document", JSON.stringify(values));
//           data.append("searchValue", JSON.stringify(searchValue));
//           data.append("startDate", adjustedDate.toISOString().slice(0, 10));
//           data.append("endDate", adjustedDates.toISOString().slice(0, 10));

//           const response = await axios.post("/appointmentpost", data, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "multipart/form-data",
//             },
//             params: {
//               hospitalcodes: userHospitalcode,
//               userrole: userrole1,
//             },
//           });

//           if (response.data.length === 0) {
//             showInfo("No appointment data found for the selected criteria.");
//             setDataSupply(response.data);
//           } else {
//             console.log(response.data);
//             setDataSupply(response.data);
//             showSuccess(
//               `Successfully loaded ${response.data.length} appointment records!`
//             );
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching appointment report:", err);

//         if (err.response?.status === 400) {
//           showError("Invalid request. Please check your inputs.");
//         } else if (err.response?.status === 403) {
//           showError("You don't have permission to access this report.");
//         } else if (err.response?.status >= 500) {
//           showError("Server error occurred. Please try again later.");
//         } else if (err.request) {
//           showError(
//             "Network error. Please check your connection and try again."
//           );
//         } else {
//           showError("Failed to load appointment report. Please try again.");
//         }
//       }
//       action.resetForm();
//     },
//   });

//   console.log(range);

//   useEffect(() => {
//     if (!localStorage.getItem("jwtToken")) {
//       return history.push("/");
//     }

//     const totalPrice = dataSupply.reduce(
//       (total, item) => total + parseFloat(item.amount || 0),
//       0
//     );
//     setTotalPrice(totalPrice);
//   }, [dataSupply]);

//   useEffect(() => {
//     document.addEventListener("keydown", hideOnEscape, true);
//     document.addEventListener("click", hideOnClickOutside, true);

//     return () => {
//       document.removeEventListener("keydown", hideOnEscape, true);
//       document.removeEventListener("click", hideOnClickOutside, true);
//     };
//   }, []);

//   const hideOnEscape = (e) => {
//     if (e.key === "Escape") {
//       setOpen(false);
//     }
//   };

//   const hideOnClickOutside = (e) => {
//     if (refOne.current && !refOne.current.contains(e.target)) {
//       setOpen(false);
//     }
//   };

//   const handleDownload = (event) => {
//     event.preventDefault();

//     try {
//       if (dataSupply.length === 0) {
//         showError("No data available to download!");
//         return;
//       }

//       const workbook = XLSX.utils.book_new();
//       const worksheet = XLSX.utils.table_to_sheet(
//         document.getElementById("supplyitem")
//       );

//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const excelBuffer = XLSX.write(workbook, {
//         bookType: "xlsx",
//         type: "array",
//       });

//       const data = new Blob([excelBuffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       saveAs(data, "Appointment_report.xlsx");

//       showSuccess("Appointment report downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading report:", error);
//       showError("Failed to download report. Please try again.");
//     }
//   };

//   const currentDomain = window.location.hostname;

//   return (
//     <div>
//       <Helmet>
//         <title>
//           Appointment Report | {currentDomain} | Hospital Management Software |
//           Smart Solutions for Hospital Efficiency
//         </title>
//       </Helmet>
//       <div className="">
//         <form onSubmit={handleSubmit}>
//           <div className="input-employeecontainer">
//             <div className="input-blockemployee">
//               <label htmlFor="date" className="input-labelemployee">
//                 Created on
//               </label>
//               <div className="calendarWrap">
//                 <input
//                   type="text"
//                   name="date"
//                   id="date"
//                   value={`${format(
//                     range[0].startDate,
//                     "dd/MM/yyyy"
//                   )} to ${format(range[0].endDate, "dd/MM/yyyy")}`}
//                   readOnly
//                   onClick={() => setOpen((open) => !open)}
//                 />
//                 <div ref={refOne}>
//                   {open && (
//                     <DateRangePicker
//                       onChange={(item) => setRange([item.selection])}
//                       editableDateInputs={true}
//                       moveRangeOnFirstSelection={false}
//                       ranges={range}
//                       months={1}
//                       direction="vertical"
//                       className="calendarElement"
//                     />
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div className="input-blockemployee">
//               <label htmlFor="opdtype" className="input-labelemployee">
//                 OPD type
//               </label>
//               <div className="inputerroremployee">
//                 <select
//                   type="text"
//                   autoComplete="off"
//                   name="opdtype"
//                   id="opdtype"
//                   value={values.opdtype}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                   <option>Select OPD type</option>
//                   <option>New</option>
//                   <option>Visit</option>
//                 </select>
//               </div>
//             </div>
//           </div>
//           <div className="input-employeecontainer">
//             <div className="input-blockemployee">
//               <label htmlFor="idforrequisition" className="input-labelemployee">
//                 OPD Number
//               </label>
//               <div className="inputerroremployee">
//                 <Apointmentsearch onSearchChange={handleSearchChange} />
//               </div>
//             </div>
//             {isAuthorized ? (
//               <div className="input-blockemployee">
//                 <label htmlFor="hospitalcode" className="input-labelemployee">
//                   Hospital code
//                 </label>
//                 <div className="inputerroremployee">
//                   <HospitalCodeSearch onSearchItem={onSearchItems} />
//                 </div>
//               </div>
//             ) : null}
//           </div>

//           <div className="buttonDisplay">
//             <button className="allbuttonget">Get Details</button>
//             <FaFileDownload className="download" onClick={handleDownload} />
//           </div>
//           <br />
//           <div className="container2">
//             <table id="supplyitem">
//               <thead>
//                 <tr>
//                   <th>OPD Number</th>
//                   <th>Patient Id</th>
//                   <th>OPD Type </th>
//                   <th>Full Name</th>
//                   <th>Mobile No</th>
//                   <th>Appointment Time</th>
//                   <th>Created On</th>
//                   <th>Doctor</th>
//                   {isAuthorized ? <th>Hospital Code</th> : null}
//                 </tr>
//               </thead>

//               <tbody>
//                 {dataSupply.map((value, key) => {
//                   return (
//                     <tr key={key}>
//                       <td>{value.opdnumber}</td>
//                       <td>{value.patientid}</td>
//                       <td>{value.opdtype}</td>
//                       <td>{value.patientname}</td>
//                       <td>{value.phoneno}</td>
//                       <td>{value.appointmentdate}</td>
//                       <td>{value.createdon}</td>
//                       <td>{value.fname}</td>
//                       {isAuthorized ? <td>{value.hospitalcode}</td> : null}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AppointmentReport;

// import { useEffect, useRef, useState, useCallback } from "react";
// import { useFormik } from "formik";
// import { Helmet } from "react-helmet";
// import axios from "./../../helper/axios";
// import { useHistory } from "react-router-dom";
// import { DateRangePicker } from "react-date-range";
// import format from "date-fns/format";
// import { subDays } from "date-fns";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// import { FaFileDownload } from "react-icons/fa";
// import Apointmentsearch from "../../Component/Apointmentsearch";
// import { useUser } from "../../Provider";
// import HospitalCodeSearch from "../../Component/HospitalCodeSearch";
// import { useToast } from "../ToastSystem";

// const initialValues = { opdnumber: "", opdtype: "", hospitalcode: "" };

// const toLocalISO = (date) => {
//   const offset = date.getTimezoneOffset() * 60000;
//   return new Date(date.getTime() - offset).toISOString().slice(0, 10);
// };

// // ─── Professional HTML Report Generator ───────────────────────────────────
// const generateAppointmentReportHTML = ({
//   data,
//   startDate,
//   endDate,
//   hospitalcode,
//   isAuthorized,
// }) => {
//   const total = data.length;
//   const newPatients = data.filter((r) => r.opdtype === "New").length;
//   const visitPatients = data.filter((r) => r.opdtype === "Visit").length;
//   const generated = format(new Date(), "dd MMM yyyy, HH:mm");

//   // Daily breakdown
//   const dailyMap = {};
//   const dailyNewMap = {};
//   const dailyVisitMap = {};
//   for (const row of data) {
//     const day = row.createdon?.slice(0, 10) || "Unknown";
//     dailyMap[day] = (dailyMap[day] || 0) + 1;
//     if (row.opdtype === "New") dailyNewMap[day] = (dailyNewMap[day] || 0) + 1;
//     if (row.opdtype === "Visit")
//       dailyVisitMap[day] = (dailyVisitMap[day] || 0) + 1;
//   }
//   const dailyEntries = Object.entries(dailyMap).sort(([a], [b]) =>
//     a.localeCompare(b),
//   );
//   const maxDaily = Math.max(...Object.values(dailyMap), 1);

//   const todayKey = new Date().toISOString().slice(0, 10);
//   const todayTotal = dailyMap[todayKey] || 0;
//   const todayNew = dailyNewMap[todayKey] || 0;
//   const todayVisit = dailyVisitMap[todayKey] || 0;

//   // Doctor-wise breakdown
//   const doctorMap = {};
//   for (const row of data) {
//     const doc = row.fname || "Unknown";
//     doctorMap[doc] = (doctorMap[doc] || 0) + 1;
//   }
//   const topDoctors = Object.entries(doctorMap)
//     .sort(([, a], [, b]) => b - a)
//     .slice(0, 5);
//   const maxDoc = topDoctors[0]?.[1] || 1;

//   const barsHTML = dailyEntries
//     .map(([day, cnt]) => {
//       const newCnt = dailyNewMap[day] || 0;
//       const visitCnt = dailyVisitMap[day] || 0;
//       const pctNew = Math.round((newCnt / maxDaily) * 100);
//       const pctVisit = Math.round((visitCnt / maxDaily) * 100);
//       return `<div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">
//         <span style="width:90px;text-align:right;font-size:12px;color:#6b7280;flex-shrink:0;">${day}</span>
//         <div style="flex:1;background:#f3f4f6;border-radius:4px;height:10px;display:flex;overflow:hidden;">
//           <div style="width:${pctNew}%;background:#1d4ed8;height:10px;"></div>
//           <div style="width:${pctVisit}%;background:#7c3aed;height:10px;"></div>
//         </div>
//         <span style="width:30px;font-size:12px;font-weight:600;color:#111827;text-align:right;">${cnt}</span>
//         <span style="font-size:11px;color:#6b7280;white-space:nowrap;">(N:${newCnt} V:${visitCnt})</span>
//       </div>`;
//     })
//     .join("");

//   const doctorBarsHTML = topDoctors
//     .map(([doc, cnt]) => {
//       const pct = Math.round((cnt / maxDoc) * 100);
//       return `<div style="display:flex;align-items:center;gap:10px;margin-bottom:6px;">
//         <span style="width:110px;text-align:right;font-size:12px;color:#6b7280;flex-shrink:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${doc}</span>
//         <div style="flex:1;background:#f3f4f6;border-radius:3px;height:8px;">
//           <div style="width:${pct}%;background:#0891b2;height:8px;border-radius:3px;"></div>
//         </div>
//         <span style="width:30px;font-size:12px;font-weight:600;text-align:right;">${cnt}</span>
//       </div>`;
//     })
//     .join("");

//   const rowsHTML = data
//     .map(
//       (r, i) => `<tr style="background:${i % 2 === 0 ? "#fff" : "#f9fafb"}">
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.opdnumber}</td>
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.patientid}</td>
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">
//           <span style="padding:2px 8px;border-radius:20px;font-size:11px;font-weight:500;
//             background:${r.opdtype === "New" ? "#dbeafe" : "#ede9fe"};
//             color:${r.opdtype === "New" ? "#1e40af" : "#5b21b6"};">${r.opdtype}</span>
//         </td>
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.patientname}</td>
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.phoneno}</td>
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.appointmentdate}</td>
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.createdon}</td>
//         <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.fname}</td>
//         ${isAuthorized ? `<td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.hospitalcode}</td>` : ""}
//       </tr>`,
//     )
//     .join("");

//   const newPct = total ? Math.round((newPatients / total) * 100) : 0;
//   const visitPct = total ? Math.round((visitPatients / total) * 100) : 0;

//   return `<!DOCTYPE html>
// <html lang="en">
// <head>
//   <meta charset="UTF-8"/>
//   <title>Appointment Report ${startDate}</title>
//   <style>
//     @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
//     * { box-sizing: border-box; margin: 0; padding: 0; }
//     body { font-family: 'Inter', sans-serif; font-size: 13px; color: #111827; background: #f9fafb; }
//     .page { max-width: 960px; margin: 0 auto; background: #fff; min-height: 100vh; }
//     .top-bar { background: linear-gradient(135deg, #1d4ed8 0%, #4f46e5 100%); color: #fff; padding: 20px 32px; display: flex; justify-content: space-between; align-items: flex-start; }
//     .top-bar h1 { font-size: 20px; font-weight: 600; letter-spacing: -0.02em; }
//     .top-bar p { font-size: 12px; opacity: 0.75; margin-top: 3px; }
//     .top-bar-right { text-align: right; font-size: 12px; opacity: 0.85; line-height: 2; }
//     .content { padding: 24px 32px; }
//     .kpi-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 20px; }
//     .kpi { border-radius: 8px; padding: 14px 16px; border: 1px solid; }
//     .kpi-blue  { background:#eff6ff; border-color:#bfdbfe; }
//     .kpi-purple{ background:#f5f3ff; border-color:#ddd6fe; }
//     .kpi-cyan  { background:#ecfeff; border-color:#a5f3fc; }
//     .kpi-green { background:#f0fdf4; border-color:#bbf7d0; }
//     .kpi-label { font-size:11px; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em; margin-bottom:6px; }
//     .kpi-value { font-size:22px; font-weight:600; }
//     .kpi-blue .kpi-value   { color:#1e3a8a; }
//     .kpi-purple .kpi-value { color:#4c1d95; }
//     .kpi-cyan .kpi-value   { color:#164e63; }
//     .kpi-green .kpi-value  { color:#14532d; }
//     .kpi-sub { font-size:11px; color:#9ca3af; margin-top:3px; }
//     .today-row { display:grid; grid-template-columns: repeat(3,1fr); gap:12px; margin-bottom:20px; }
//     .today-card { background:#fafafa; border:1px solid #e5e7eb; border-radius:8px; padding:12px 16px; }
//     .today-label { font-size:11px; color:#9ca3af; text-transform:uppercase; letter-spacing:0.05em; margin-bottom:4px; }
//     .today-value { font-size:18px; font-weight:600; color:#111827; }
//     .two-col { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:20px; }
//     .section { border:1px solid #e5e7eb; border-radius:8px; overflow:hidden; margin-bottom:20px; }
//     .section-header { padding:10px 16px; background:#f9fafb; border-bottom:1px solid #e5e7eb; display:flex; justify-content:space-between; align-items:center; }
//     .section-title { font-size:11px; font-weight:600; color:#374151; text-transform:uppercase; letter-spacing:0.06em; }
//     .section-body { padding:14px 16px; }
//     .legend { display:flex; gap:16px; font-size:11px; color:#6b7280; }
//     .legend span { display:flex; align-items:center; gap:4px; }
//     .dot { width:10px; height:10px; border-radius:2px; flex-shrink:0; }
//     table { width:100%; border-collapse:collapse; }
//     th { padding:8px 10px; text-align:left; font-size:10px; font-weight:600; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em; background:#f9fafb; border-bottom:1px solid #e5e7eb; white-space:nowrap; }
//     .footer-bar { background:#f9fafb; border-top:1px solid #e5e7eb; padding:12px 16px; display:flex; justify-content:flex-end; gap:32px; }
//     .foot-item { text-align:right; }
//     .foot-label { font-size:11px; color:#9ca3af; }
//     .foot-value { font-size:14px; font-weight:600; color:#111827; }
//     .donut-row { display:flex; align-items:center; gap:20px; padding:8px 0; }
//     .donut-label { font-size:12px; font-weight:500; color:#374151; flex:1; }
//     .donut-bar { width:120px; height:8px; background:#f3f4f6; border-radius:4px; overflow:hidden; }
//     .donut-fill-blue   { height:8px; background:#1d4ed8; border-radius:4px; }
//     .donut-fill-purple { height:8px; background:#7c3aed; border-radius:4px; }
//     .donut-count { font-size:12px; font-weight:600; color:#111827; width:30px; text-align:right; }
//     .donut-pct { font-size:11px; color:#9ca3af; width:36px; text-align:right; }
//     .print-note { text-align:center; font-size:11px; color:#9ca3af; padding:20px; }
//     @media print {
//       body { background:#fff; }
//       .page { max-width:100%; }
//       .print-note { display:none; }
//       .top-bar { -webkit-print-color-adjust:exact; print-color-adjust:exact; }
//     }
//   </style>
// </head>
// <body>
// <div class="page">

//   <div class="top-bar">
//     <div>
//       <h1>OPD Appointment Report</h1>
//       <p>${format(new Date(startDate), "dd MMM yyyy")} &ndash; ${format(new Date(endDate), "dd MMM yyyy")}</p>
//     </div>
//     <div class="top-bar-right">
//       ${isAuthorized && hospitalcode ? `Hospital: ${hospitalcode}<br>` : ""}
//       Generated: ${generated}<br>
//       Report type: OPD appointment
//     </div>
//   </div>

//   <div class="content">

//     <!-- KPIs -->
//     <div class="kpi-grid">
//       <div class="kpi kpi-blue">
//         <div class="kpi-label">Total appointments</div>
//         <div class="kpi-value">${total}</div>
//         <div class="kpi-sub">Period total</div>
//       </div>
//       <div class="kpi kpi-blue">
//         <div class="kpi-label">New patients</div>
//         <div class="kpi-value">${newPatients}</div>
//         <div class="kpi-sub">${newPct}% of total</div>
//       </div>
//       <div class="kpi kpi-purple">
//         <div class="kpi-label">Follow-up visits</div>
//         <div class="kpi-value">${visitPatients}</div>
//         <div class="kpi-sub">${visitPct}% of total</div>
//       </div>
//       <div class="kpi kpi-cyan">
//         <div class="kpi-label">Unique doctors</div>
//         <div class="kpi-value">${Object.keys(doctorMap).length}</div>
//         <div class="kpi-sub">Consulted this period</div>
//       </div>
//     </div>

//     <!-- Today cards -->
//     <div class="today-row">
//       <div class="today-card">
//         <div class="today-label">Today — total</div>
//         <div class="today-value">${todayTotal}</div>
//       </div>
//       <div class="today-card">
//         <div class="today-label">Today — new patients</div>
//         <div class="today-value">${todayNew}</div>
//       </div>
//       <div class="today-card">
//         <div class="today-label">Today — follow-ups</div>
//         <div class="today-value">${todayVisit}</div>
//       </div>
//     </div>

//     <!-- Charts row -->
//     <div class="two-col">
//       <div class="section">
//         <div class="section-header">
//           <span class="section-title">Daily breakdown</span>
//           <div class="legend">
//             <span><span class="dot" style="background:#1d4ed8"></span>New</span>
//             <span><span class="dot" style="background:#7c3aed"></span>Visit</span>
//           </div>
//         </div>
//         <div class="section-body">
//           ${barsHTML || "<p style='font-size:12px;color:#9ca3af;'>No data</p>"}
//         </div>
//       </div>

//       <div class="section">
//         <div class="section-header">
//           <span class="section-title">OPD type split</span>
//         </div>
//         <div class="section-body">
//           <div class="donut-row">
//             <div class="donut-label">New patients</div>
//             <div class="donut-bar"><div class="donut-fill-blue" style="width:${newPct}%"></div></div>
//             <div class="donut-count">${newPatients}</div>
//             <div class="donut-pct">${newPct}%</div>
//           </div>
//           <div class="donut-row">
//             <div class="donut-label">Follow-up visits</div>
//             <div class="donut-bar"><div class="donut-fill-purple" style="width:${visitPct}%"></div></div>
//             <div class="donut-count">${visitPatients}</div>
//             <div class="donut-pct">${visitPct}%</div>
//           </div>
//           <div style="margin-top:20px;">
//             <div class="section-title" style="margin-bottom:12px;">Top doctors by appointments</div>
//             ${doctorBarsHTML || "<p style='font-size:12px;color:#9ca3af;'>No data</p>"}
//           </div>
//         </div>
//       </div>
//     </div>

//     <!-- Detail table -->
//     <div class="section">
//       <div class="section-header">
//         <span class="section-title">Appointment records</span>
//         <span style="font-size:11px;color:#9ca3af;">${total} records</span>
//       </div>
//       <div style="overflow-x:auto;">
//         <table>
//           <thead>
//             <tr>
//               <th>OPD No.</th>
//               <th>Patient ID</th>
//               <th>Type</th>
//               <th>Patient name</th>
//               <th>Mobile</th>
//               <th>Appt. date</th>
//               <th>Created on</th>
//               <th>Doctor</th>
//               ${isAuthorized ? "<th>Hospital</th>" : ""}
//             </tr>
//           </thead>
//           <tbody>${rowsHTML}</tbody>
//         </table>
//       </div>
//       <div class="footer-bar">
//         <div class="foot-item"><div class="foot-label">New</div><div class="foot-value">${newPatients}</div></div>
//         <div class="foot-item"><div class="foot-label">Visits</div><div class="foot-value">${visitPatients}</div></div>
//         <div class="foot-item"><div class="foot-label">Total appointments</div><div class="foot-value">${total}</div></div>
//       </div>
//     </div>

//   </div>
//   <p class="print-note">To save as PDF: File &rarr; Print &rarr; Save as PDF</p>
// </div>
// </body>
// </html>`;
// };

// // ─── Main Component ────────────────────────────────────────────────────────
// const AppointmentReport = () => {
//   const history = useHistory();
//   const { userHospitalcode, userrole1, isAuthorized, token } = useUser();
//   const { showSuccess, showError, showInfo } = useToast();

//   const [searchValue, setSearchValue] = useState("");
//   const [dataSupply, setDataSupply] = useState([]);
//   const [range, setRange] = useState([
//     {
//       endDate: new Date(),
//       startDate: subDays(new Date(), 7),
//       key: "selection",
//     },
//   ]);
//   const [open, setOpen] = useState(false);
//   const refOne = useRef(null);

//   useEffect(() => {
//     if (!localStorage.getItem("jwtToken")) return history.push("/");
//     const hideOnEscape = (e) => e.key === "Escape" && setOpen(false);
//     const hideOnClickOutside = (e) =>
//       refOne.current && !refOne.current.contains(e.target) && setOpen(false);
//     document.addEventListener("keydown", hideOnEscape, true);
//     document.addEventListener("click", hideOnClickOutside, true);
//     return () => {
//       document.removeEventListener("keydown", hideOnEscape, true);
//       document.removeEventListener("click", hideOnClickOutside, true);
//     };
//   }, []);

//   const { values, handleChange, handleBlur, handleSubmit, setValues } =
//     useFormik({
//       initialValues,
//       onSubmit: async (values, action) => {
//         try {
//           if (!userHospitalcode || !userrole1) return;

//           const formData = new FormData();
//           formData.append("document", JSON.stringify(values));
//           formData.append("searchValue", JSON.stringify(searchValue));
//           formData.append("startDate", toLocalISO(range[0].startDate));
//           formData.append("endDate", toLocalISO(range[0].endDate));

//           const response = await axios.post("/appointmentpost", formData, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "multipart/form-data",
//             },
//             params: { hospitalcodes: userHospitalcode, userrole: userrole1 },
//           });

//           if (response.data.length === 0) {
//             showInfo("No appointment data found for the selected criteria.");
//           } else {
//             showSuccess(`Loaded ${response.data.length} appointment records.`);
//           }
//           setDataSupply(response.data);
//           console.log("Fetched appointment data:", response.data);
//         } catch (err) {
//           const status = err.response?.status;
//           if (status === 400)
//             showError("Invalid request. Please check your inputs.");
//           else if (status === 403)
//             showError("You don't have permission to access this report.");
//           else if (status >= 500)
//             showError("Server error. Please try again later.");
//           else if (err.request)
//             showError("Network error. Check your connection.");
//           else showError("Failed to load appointment report.");
//         }
//         action.resetForm();
//       },
//     });

//   const handleDownload = useCallback(
//     (e) => {
//       e.preventDefault();
//       if (!dataSupply.length) {
//         showError("No data to download. Fetch records first.");
//         return;
//       }
//       try {
//         const html = generateAppointmentReportHTML({
//           data: dataSupply,
//           startDate: toLocalISO(range[0].startDate),
//           endDate: toLocalISO(range[0].endDate),
//           hospitalcode: values.hospitalcode,
//           isAuthorized,
//         });
//         const blob = new Blob([html], { type: "text/html" });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `Appointment_Report_${toLocalISO(range[0].startDate)}_to_${toLocalISO(range[0].endDate)}.html`;
//         a.click();
//         URL.revokeObjectURL(url);
//         showSuccess(
//           "Report downloaded! Open in browser → Print → Save as PDF to share.",
//         );
//       } catch {
//         showError("Failed to generate report.");
//       }
//     },
//     [dataSupply, range, values.hospitalcode, isAuthorized],
//   );

//   const currentDomain = window.location.hostname;

//   return (
//     <div>
//       <Helmet>
//         <title>
//           Appointment Report | {currentDomain} | Hospital Management Software
//         </title>
//       </Helmet>

//       <form onSubmit={handleSubmit}>
//         <div className="input-employeecontainer">
//           <div className="input-blockemployee">
//             <label htmlFor="date" className="input-labelemployee">
//               Created on
//             </label>
//             <div className="calendarWrap">
//               <input
//                 type="text"
//                 name="date"
//                 id="date"
//                 value={`${format(range[0].startDate, "dd/MM/yyyy")} to ${format(range[0].endDate, "dd/MM/yyyy")}`}
//                 readOnly
//                 onClick={() => setOpen((o) => !o)}
//               />
//               <div ref={refOne}>
//                 {open && (
//                   <DateRangePicker
//                     onChange={(item) => setRange([item.selection])}
//                     editableDateInputs
//                     moveRangeOnFirstSelection={false}
//                     ranges={range}
//                     months={1}
//                     direction="vertical"
//                     className="calendarElement"
//                   />
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="input-blockemployee">
//             <label htmlFor="opdtype" className="input-labelemployee">
//               OPD Type
//             </label>
//             <select
//               name="opdtype"
//               id="opdtype"
//               value={values.opdtype}
//               onChange={handleChange}
//               onBlur={handleBlur}
//             >
//               <option value="">All (New + Visit)</option>
//               <option value="New">New</option>
//               <option value="Visit">Visit</option>
//             </select>
//           </div>
//         </div>

//         <div className="input-employeecontainer">
//           <div className="input-blockemployee">
//             <label className="input-labelemployee">OPD Number</label>
//             <Apointmentsearch onSearchChange={(v) => setSearchValue(v)} />
//           </div>

//           {isAuthorized && (
//             <div className="input-blockemployee">
//               <label htmlFor="hospitalcode" className="input-labelemployee">
//                 Hospital Code
//               </label>
//               <HospitalCodeSearch
//                 onSearchItem={(item) =>
//                   setValues((v) => ({ ...v, hospitalcode: item.hospitalcode }))
//                 }
//               />
//             </div>
//           )}
//         </div>

//         <div className="buttonDisplay">
//           <button type="submit" className="allbuttonget">
//             Get Details
//           </button>
//           <FaFileDownload
//             className="download"
//             onClick={handleDownload}
//             title="Download professional report"
//             style={{ cursor: "pointer" }}
//           />
//         </div>

//         <div className="container2">
//           <table id="supplyitem">
//             <thead>
//               <tr>
//                 <th>OPD Number</th>
//                 <th>Patient ID</th>
//                 <th>OPD Type</th>
//                 <th>Full Name</th>
//                 <th>Mobile No</th>
//                 <th>Appointment Time</th>
//                 <th>Created On</th>
//                 <th>Doctor</th>
//                 {isAuthorized && <th>Hospital Code</th>}
//               </tr>
//             </thead>
//             <tbody>
//               {dataSupply.map((row, i) => (
//                 <tr key={i}>
//                   <td>{row.opdnumber}</td>
//                   <td>{row.patientid}</td>
//                   <td>{row.opdtype}</td>
//                   <td>{row.patientname}</td>
//                   <td>{row.phoneno}</td>
//                   <td>{row.appointmentdate}</td>
//                   <td>{row.createdon}</td>
//                   <td>{row.fname}</td>
//                   {isAuthorized && <td>{row.hospitalcode}</td>}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AppointmentReport;

import { useEffect, useRef, useState, useCallback } from "react";
import { useFormik } from "formik";
import { Helmet } from "react-helmet";
import axios from "./../../helper/axios";
import { useHistory } from "react-router-dom";
import { DateRangePicker } from "react-date-range";
import format from "date-fns/format";
import { subDays } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { FaFileDownload } from "react-icons/fa";
import Apointmentsearch from "../../Component/Apointmentsearch";
import { useUser } from "../../Provider";
import HospitalCodeSearch from "../../Component/HospitalCodeSearch";
import { useToast } from "../ToastSystem";

const initialValues = { opdnumber: "", opdtype: "", hospitalcode: "" };

const toLocalISO = (date) => {
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 10);
};

const formatINR = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount || 0);

// ─── Professional HTML Report Generator ───────────────────────────────────
const generateAppointmentReportHTML = ({
  data,
  startDate,
  endDate,
  hospitalcode,
  isAuthorized,
}) => {
  const total = data.length;
  const newPatients = data.filter((r) => r.opdtype === "New").length;
  const visitPatients = data.filter((r) => r.opdtype === "Visit").length;
  const generated = format(new Date(), "dd MMM yyyy, HH:mm");

  // ── Revenue calculations ──────────────────────────────────────────────
  const totalRevenue = data.reduce(
    (sum, r) => sum + parseFloat(r.doctorfees || 0),
    0,
  );
  const newRevenue = data
    .filter((r) => r.opdtype === "New")
    .reduce((sum, r) => sum + parseFloat(r.doctorfees || 0), 0);
  const visitRevenue = data
    .filter((r) => r.opdtype === "Visit")
    .reduce((sum, r) => sum + parseFloat(r.doctorfees || 0), 0);
  const avgRevenue = total ? totalRevenue / total : 0;

  // ── Daily breakdown ───────────────────────────────────────────────────
  const dailyMap = {};
  const dailyNewMap = {};
  const dailyVisitMap = {};
  const dailyRevenueMap = {};

  for (const row of data) {
    const day = row.createdon?.slice(0, 10) || "Unknown";
    const fee = parseFloat(row.doctorfees || 0);
    dailyMap[day] = (dailyMap[day] || 0) + 1;
    dailyRevenueMap[day] = (dailyRevenueMap[day] || 0) + fee;
    if (row.opdtype === "New") dailyNewMap[day] = (dailyNewMap[day] || 0) + 1;
    if (row.opdtype === "Visit")
      dailyVisitMap[day] = (dailyVisitMap[day] || 0) + 1;
  }

  const dailyEntries = Object.entries(dailyMap).sort(([a], [b]) =>
    a.localeCompare(b),
  );
  const maxDaily = Math.max(...Object.values(dailyMap), 1);

  const todayKey = new Date().toISOString().slice(0, 10);
  const todayTotal = dailyMap[todayKey] || 0;
  const todayNew = dailyNewMap[todayKey] || 0;
  const todayVisit = dailyVisitMap[todayKey] || 0;
  const todayRevenue = dailyRevenueMap[todayKey] || 0;

  // ── Doctor-wise breakdown ─────────────────────────────────────────────
  const doctorMap = {};
  const doctorRevenueMap = {};
  for (const row of data) {
    const doc = row.fname || "Unknown";
    doctorMap[doc] = (doctorMap[doc] || 0) + 1;
    doctorRevenueMap[doc] =
      (doctorRevenueMap[doc] || 0) + parseFloat(row.doctorfees || 0);
  }
  const topDoctors = Object.entries(doctorMap)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 5);
  const maxDoc = topDoctors[0]?.[1] || 1;

  const newPct = total ? Math.round((newPatients / total) * 100) : 0;
  const visitPct = total ? Math.round((visitPatients / total) * 100) : 0;
  const newRevPct = totalRevenue
    ? Math.round((newRevenue / totalRevenue) * 100)
    : 0;
  const visitRevPct = totalRevenue
    ? Math.round((visitRevenue / totalRevenue) * 100)
    : 0;

  // ── HTML builders ─────────────────────────────────────────────────────
  const barsHTML = dailyEntries
    .map(([day, cnt]) => {
      const newCnt = dailyNewMap[day] || 0;
      const visitCnt = dailyVisitMap[day] || 0;
      const rev = dailyRevenueMap[day] || 0;
      const pctNew = Math.round((newCnt / maxDaily) * 100);
      const pctVisit = Math.round((visitCnt / maxDaily) * 100);
      return `<div style="display:flex;align-items:center;gap:10px;margin-bottom:9px;">
        <span style="width:88px;text-align:right;font-size:11px;color:#6b7280;flex-shrink:0;">${day}</span>
        <div style="flex:1;background:#f3f4f6;border-radius:4px;height:10px;display:flex;overflow:hidden;">
          <div style="width:${pctNew}%;background:#1d4ed8;height:10px;"></div>
          <div style="width:${pctVisit}%;background:#7c3aed;height:10px;"></div>
        </div>
        <span style="width:28px;font-size:12px;font-weight:600;color:#111827;text-align:right;">${cnt}</span>
        <span style="width:72px;font-size:11px;color:#059669;text-align:right;font-weight:500;">${formatINR(rev)}</span>
      </div>`;
    })
    .join("");

  const doctorBarsHTML = topDoctors
    .map(([doc, cnt]) => {
      const pct = Math.round((cnt / maxDoc) * 100);
      const rev = doctorRevenueMap[doc] || 0;
      return `<div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">
        <span style="width:100px;text-align:right;font-size:11px;color:#6b7280;flex-shrink:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${doc}</span>
        <div style="flex:1;background:#f3f4f6;border-radius:3px;height:8px;">
          <div style="width:${pct}%;background:#0891b2;height:8px;border-radius:3px;"></div>
        </div>
        <span style="width:24px;font-size:12px;font-weight:600;text-align:right;">${cnt}</span>
        <span style="width:80px;font-size:11px;color:#059669;font-weight:500;text-align:right;">${formatINR(rev)}</span>
      </div>`;
    })
    .join("");

  const rowsHTML = data
    .map(
      (r, i) =>
        `<tr style="background:${i % 2 === 0 ? "#fff" : "#f9fafb"}">
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.opdnumber}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.patientid}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">
            <span style="padding:2px 8px;border-radius:20px;font-size:11px;font-weight:500;
              background:${r.opdtype === "New" ? "#dbeafe" : "#ede9fe"};
              color:${r.opdtype === "New" ? "#1e40af" : "#5b21b6"};">${r.opdtype}</span>
          </td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.patientname}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.phoneno}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.appointmentdate}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.createdon}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.fname}</td>
          <td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;text-align:right;font-weight:500;color:#059669;">${formatINR(r.doctorfees)}</td>
          ${isAuthorized ? `<td style="padding:8px 10px;border-bottom:1px solid #e5e7eb;">${r.hospitalcode}</td>` : ""}
        </tr>`,
    )
    .join("");

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8"/>
  <title>OPD Appointment Report — ${startDate}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
    * { box-sizing:border-box; margin:0; padding:0; }
    body { font-family:'Inter',sans-serif; font-size:13px; color:#111827; background:#f3f4f6; }
    .page { max-width:1000px; margin:0 auto; background:#fff; min-height:100vh; }

    /* Header */
    .top-bar { background:linear-gradient(135deg,#1d4ed8 0%,#4f46e5 100%); color:#fff; padding:22px 32px; display:flex; justify-content:space-between; align-items:flex-start; }
    .top-bar h1 { font-size:20px; font-weight:600; letter-spacing:-0.02em; }
    .top-bar .sub { font-size:12px; opacity:0.75; margin-top:4px; }
    .top-bar-right { text-align:right; font-size:12px; opacity:0.85; line-height:2; }

    /* Revenue banner */
    .rev-banner { background:#f0fdf4; border-bottom:1px solid #bbf7d0; padding:14px 32px; display:flex; gap:40px; align-items:center; }
    .rev-item { display:flex; flex-direction:column; }
    .rev-label { font-size:10px; color:#6b7280; text-transform:uppercase; letter-spacing:0.06em; margin-bottom:3px; }
    .rev-value { font-size:18px; font-weight:600; color:#065f46; }
    .rev-sub   { font-size:11px; color:#6b7280; margin-top:2px; }
    .rev-divider { width:1px; height:36px; background:#bbf7d0; }

    .content { padding:24px 32px; }

    /* KPI grid */
    .kpi-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; margin-bottom:16px; }
    .kpi { border-radius:8px; padding:14px 16px; border:1px solid; }
    .kpi-blue   { background:#eff6ff; border-color:#bfdbfe; }
    .kpi-purple { background:#f5f3ff; border-color:#ddd6fe; }
    .kpi-cyan   { background:#ecfeff; border-color:#a5f3fc; }
    .kpi-green  { background:#f0fdf4; border-color:#bbf7d0; }
    .kpi-label  { font-size:10px; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em; margin-bottom:6px; }
    .kpi-value  { font-size:21px; font-weight:600; }
    .kpi-blue   .kpi-value { color:#1e3a8a; }
    .kpi-purple .kpi-value { color:#4c1d95; }
    .kpi-cyan   .kpi-value { color:#164e63; }
    .kpi-green  .kpi-value { color:#065f46; }
    .kpi-sub { font-size:11px; color:#9ca3af; margin-top:3px; }

    /* Today strip */
    .today-row { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; margin-bottom:20px; }
    .today-card { background:#fafafa; border:1px solid #e5e7eb; border-radius:8px; padding:12px 14px; }
    .today-label { font-size:10px; color:#9ca3af; text-transform:uppercase; letter-spacing:0.05em; margin-bottom:4px; }
    .today-value { font-size:17px; font-weight:600; color:#111827; }
    .today-value.green { color:#065f46; }

    /* Layout */
    .two-col { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:20px; }
    .section { border:1px solid #e5e7eb; border-radius:8px; overflow:hidden; margin-bottom:20px; }
    .section-header { padding:10px 16px; background:#f9fafb; border-bottom:1px solid #e5e7eb; display:flex; justify-content:space-between; align-items:center; }
    .section-title { font-size:10px; font-weight:600; color:#374151; text-transform:uppercase; letter-spacing:0.07em; }
    .section-body { padding:14px 16px; }
    .legend { display:flex; gap:14px; font-size:11px; color:#6b7280; }
    .legend span { display:flex; align-items:center; gap:4px; }
    .dot { width:10px; height:10px; border-radius:2px; flex-shrink:0; }

    /* Split bars */
    .split-row { display:flex; align-items:center; gap:14px; padding:9px 0; border-bottom:1px solid #f3f4f6; }
    .split-row:last-child { border-bottom:none; }
    .split-label { font-size:12px; font-weight:500; color:#374151; flex:1; }
    .split-bar { width:110px; height:8px; background:#f3f4f6; border-radius:4px; overflow:hidden; }
    .split-fill-blue   { height:8px; background:#1d4ed8; }
    .split-fill-purple { height:8px; background:#7c3aed; }
    .split-count { font-size:12px; font-weight:600; color:#111827; width:28px; text-align:right; }
    .split-pct   { font-size:11px; color:#9ca3af; width:32px; text-align:right; }
    .split-rev   { font-size:11px; color:#059669; font-weight:500; width:72px; text-align:right; }

    /* Table */
    table { width:100%; border-collapse:collapse; }
    th { padding:8px 10px; text-align:left; font-size:10px; font-weight:600; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em; background:#f9fafb; border-bottom:1px solid #e5e7eb; white-space:nowrap; }
    .footer-bar { background:#f9fafb; border-top:2px solid #e5e7eb; padding:12px 16px; display:flex; justify-content:flex-end; gap:32px; }
    .foot-item { text-align:right; }
    .foot-label { font-size:10px; color:#9ca3af; text-transform:uppercase; letter-spacing:0.04em; }
    .foot-value { font-size:14px; font-weight:600; color:#111827; margin-top:2px; }
    .foot-value.green { color:#065f46; }

    .print-note { text-align:center; font-size:11px; color:#9ca3af; padding:20px; }
    @media print {
      body { background:#fff; }
      .page { max-width:100%; }
      .print-note { display:none; }
      .top-bar,.rev-banner { -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    }
  </style>
</head>
<body>
<div class="page">

  <!-- Header -->
  <div class="top-bar">
    <div>
      <h1>OPD Appointment Report</h1>
      <p class="sub">${format(new Date(startDate), "dd MMM yyyy")} &ndash; ${format(new Date(endDate), "dd MMM yyyy")}</p>
    </div>
    <div class="top-bar-right">
      ${isAuthorized && hospitalcode ? `Hospital: ${hospitalcode}<br>` : ""}
      Generated: ${generated}<br>
      Report type: OPD appointment
    </div>
  </div>

  <!-- Revenue summary banner -->
  <div class="rev-banner">
    <div class="rev-item">
      <span class="rev-label">Total OPD collection</span>
      <span class="rev-value">${formatINR(totalRevenue)}</span>
      <span class="rev-sub">Period total (${total} appointments)</span>
    </div>
    <div class="rev-divider"></div>
    <div class="rev-item">
      <span class="rev-label">New patient fees</span>
      <span class="rev-value">${formatINR(newRevenue)}</span>
      <span class="rev-sub">${newRevPct}% of total · ${newPatients} patients</span>
    </div>
    <div class="rev-divider"></div>
    <div class="rev-item">
      <span class="rev-label">Follow-up fees</span>
      <span class="rev-value">${formatINR(visitRevenue)}</span>
      <span class="rev-sub">${visitRevPct}% of total · ${visitPatients} visits</span>
    </div>
    <div class="rev-divider"></div>
    <div class="rev-item">
      <span class="rev-label">Average per visit</span>
      <span class="rev-value">${formatINR(avgRevenue)}</span>
      <span class="rev-sub">Across all OPD types</span>
    </div>
  </div>

  <div class="content">

    <!-- KPI cards -->
    <div class="kpi-grid">
      <div class="kpi kpi-blue">
        <div class="kpi-label">Total appointments</div>
        <div class="kpi-value">${total}</div>
        <div class="kpi-sub">Period total</div>
      </div>
      <div class="kpi kpi-blue">
        <div class="kpi-label">New patients</div>
        <div class="kpi-value">${newPatients}</div>
        <div class="kpi-sub">${newPct}% of total</div>
      </div>
      <div class="kpi kpi-purple">
        <div class="kpi-label">Follow-up visits</div>
        <div class="kpi-value">${visitPatients}</div>
        <div class="kpi-sub">${visitPct}% of total</div>
      </div>
      <div class="kpi kpi-green">
        <div class="kpi-label">Total OPD collection</div>
        <div class="kpi-value">${formatINR(totalRevenue)}</div>
        <div class="kpi-sub">All doctor fees</div>
      </div>
    </div>

    <!-- Today strip -->
    <div class="today-row">
      <div class="today-card">
        <div class="today-label">Today — total</div>
        <div class="today-value">${todayTotal} appts</div>
      </div>
      <div class="today-card">
        <div class="today-label">Today — new</div>
        <div class="today-value">${todayNew} patients</div>
      </div>
      <div class="today-card">
        <div class="today-label">Today — follow-ups</div>
        <div class="today-value">${todayVisit} visits</div>
      </div>
      <div class="today-card">
        <div class="today-label">Today — collection</div>
        <div class="today-value green">${formatINR(todayRevenue)}</div>
      </div>
    </div>

    <!-- Charts row -->
    <div class="two-col">
      <!-- Daily bar chart -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">Daily breakdown</span>
          <div class="legend">
            <span><span class="dot" style="background:#1d4ed8"></span>New</span>
            <span><span class="dot" style="background:#7c3aed"></span>Visit</span>
            <span><span class="dot" style="background:#059669"></span>₹ collected</span>
          </div>
        </div>
        <div class="section-body">
          ${barsHTML || "<p style='font-size:12px;color:#9ca3af;'>No data</p>"}
        </div>
      </div>

      <!-- Split + doctor breakdown -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">OPD type & revenue split</span>
        </div>
        <div class="section-body">
          <div class="split-row">
            <div class="split-label">New patients</div>
            <div class="split-bar"><div class="split-fill-blue" style="width:${newPct}%"></div></div>
            <div class="split-count">${newPatients}</div>
            <div class="split-pct">${newPct}%</div>
            <div class="split-rev">${formatINR(newRevenue)}</div>
          </div>
          <div class="split-row">
            <div class="split-label">Follow-up visits</div>
            <div class="split-bar"><div class="split-fill-purple" style="width:${visitPct}%"></div></div>
            <div class="split-count">${visitPatients}</div>
            <div class="split-pct">${visitPct}%</div>
            <div class="split-rev">${formatINR(visitRevenue)}</div>
          </div>

          <div style="margin-top:18px;padding-top:14px;border-top:1px solid #f3f4f6;">
            <div class="section-title" style="margin-bottom:12px;">Top doctors — appointments &amp; fees</div>
            ${doctorBarsHTML || "<p style='font-size:12px;color:#9ca3af;'>No data</p>"}
          </div>
        </div>
      </div>
    </div>

    <!-- Detail table -->
    <div class="section">
      <div class="section-header">
        <span class="section-title">Appointment records</span>
        <span style="font-size:11px;color:#9ca3af;">${total} records</span>
      </div>
      <div style="overflow-x:auto;">
        <table>
          <thead>
            <tr>
              <th>OPD No.</th>
              <th>Patient ID</th>
              <th>Type</th>
              <th>Patient name</th>
              <th>Mobile</th>
              <th>Appt. date</th>
              <th>Created on</th>
              <th>Doctor</th>
              <th style="text-align:right;">Fees</th>
              ${isAuthorized ? "<th>Hospital</th>" : ""}
            </tr>
          </thead>
          <tbody>${rowsHTML}</tbody>
        </table>
      </div>
      <div class="footer-bar">
        <div class="foot-item">
          <div class="foot-label">New</div>
          <div class="foot-value">${newPatients}</div>
        </div>
        <div class="foot-item">
          <div class="foot-label">Visits</div>
          <div class="foot-value">${visitPatients}</div>
        </div>
        <div class="foot-item">
          <div class="foot-label">Total appointments</div>
          <div class="foot-value">${total}</div>
        </div>
        <div class="foot-item">
          <div class="foot-label">New fees</div>
          <div class="foot-value green">${formatINR(newRevenue)}</div>
        </div>
        <div class="foot-item">
          <div class="foot-label">Visit fees</div>
          <div class="foot-value green">${formatINR(visitRevenue)}</div>
        </div>
        <div class="foot-item">
          <div class="foot-label">Total OPD collection</div>
          <div class="foot-value green">${formatINR(totalRevenue)}</div>
        </div>
      </div>
    </div>

  </div>
  <p class="print-note">To save as PDF — File &rarr; Print &rarr; Save as PDF</p>
</div>
</body>
</html>`;
};

// ─── Main Component ────────────────────────────────────────────────────────
const AppointmentReport = () => {
  const history = useHistory();
  const { userHospitalcode, userrole1, isAuthorized, token } = useUser();
  const { showSuccess, showError, showInfo } = useToast();

  const [searchValue, setSearchValue] = useState("");
  const [dataSupply, setDataSupply] = useState([]);
  const [range, setRange] = useState([
    {
      endDate: new Date(),
      startDate: subDays(new Date(), 7),
      key: "selection",
    },
  ]);
  const [open, setOpen] = useState(false);
  const refOne = useRef(null);

  // ── Derived revenue stats shown live on the page ──────────────────────
  const totalRevenue = dataSupply.reduce(
    (sum, r) => sum + parseFloat(r.doctorfees || 0),
    0,
  );
  const newRevenue = dataSupply
    .filter((r) => r.opdtype === "New")
    .reduce((sum, r) => sum + parseFloat(r.doctorfees || 0), 0);
  const visitRevenue = dataSupply
    .filter((r) => r.opdtype === "Visit")
    .reduce((sum, r) => sum + parseFloat(r.doctorfees || 0), 0);
  const newCount = dataSupply.filter((r) => r.opdtype === "New").length;
  const visitCount = dataSupply.filter((r) => r.opdtype === "Visit").length;

  useEffect(() => {
    if (!localStorage.getItem("jwtToken")) return history.push("/");
    const hideOnEscape = (e) => e.key === "Escape" && setOpen(false);
    const hideOnClickOutside = (e) =>
      refOne.current && !refOne.current.contains(e.target) && setOpen(false);
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
    return () => {
      document.removeEventListener("keydown", hideOnEscape, true);
      document.removeEventListener("click", hideOnClickOutside, true);
    };
  }, []);

  const { values, handleChange, handleBlur, handleSubmit, setValues } =
    useFormik({
      initialValues,
      onSubmit: async (values, action) => {
        try {
          if (!userHospitalcode || !userrole1) return;
          const formData = new FormData();
          formData.append("document", JSON.stringify(values));
          formData.append("searchValue", JSON.stringify(searchValue));
          formData.append("startDate", toLocalISO(range[0].startDate));
          formData.append("endDate", toLocalISO(range[0].endDate));

          const response = await axios.post("/appointmentpost", formData, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            params: { hospitalcodes: userHospitalcode, userrole: userrole1 },
          });

          if (response.data.length === 0) {
            showInfo("No appointment data found for the selected criteria.");
          } else {
            showSuccess(`Loaded ${response.data.length} appointment records.`);
          }
          setDataSupply(response.data);
        } catch (err) {
          const status = err.response?.status;
          if (status === 400)
            showError("Invalid request. Please check your inputs.");
          else if (status === 403)
            showError("You don't have permission to access this report.");
          else if (status >= 500)
            showError("Server error. Please try again later.");
          else if (err.request)
            showError("Network error. Check your connection.");
          else showError("Failed to load appointment report.");
        }
        action.resetForm();
      },
    });

  const handleDownload = useCallback(
    (e) => {
      e.preventDefault();
      if (!dataSupply.length) {
        showError("No data to download. Fetch records first.");
        return;
      }
      try {
        const html = generateAppointmentReportHTML({
          data: dataSupply,
          startDate: toLocalISO(range[0].startDate),
          endDate: toLocalISO(range[0].endDate),
          hospitalcode: values.hospitalcode,
          isAuthorized,
        });
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `OPD_Report_${toLocalISO(range[0].startDate)}_to_${toLocalISO(range[0].endDate)}.html`;
        a.click();
        URL.revokeObjectURL(url);
        showSuccess(
          "Report downloaded! Open in browser → Print → Save as PDF.",
        );
      } catch {
        showError("Failed to generate report.");
      }
    },
    [dataSupply, range, values.hospitalcode, isAuthorized],
  );

  const currentDomain = window.location.hostname;

  return (
    <div>
      <Helmet>
        <title>
          Appointment Report | {currentDomain} | Hospital Management Software
        </title>
      </Helmet>

      <form onSubmit={handleSubmit}>
        <div className="input-employeecontainer">
          <div className="input-blockemployee">
            <label htmlFor="date" className="input-labelemployee">
              Created on
            </label>
            <div className="calendarWrap">
              <input
                type="text"
                name="date"
                id="date"
                value={`${format(range[0].startDate, "dd/MM/yyyy")} to ${format(range[0].endDate, "dd/MM/yyyy")}`}
                readOnly
                onClick={() => setOpen((o) => !o)}
              />
              <div ref={refOne}>
                {open && (
                  <DateRangePicker
                    onChange={(item) => setRange([item.selection])}
                    editableDateInputs
                    moveRangeOnFirstSelection={false}
                    ranges={range}
                    months={1}
                    direction="vertical"
                    className="calendarElement"
                  />
                )}
              </div>
            </div>
          </div>

          <div className="input-blockemployee">
            <label htmlFor="opdtype" className="input-labelemployee">
              OPD Type
            </label>
            <select
              name="opdtype"
              id="opdtype"
              value={values.opdtype}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <option value="">All (New + Visit)</option>
              <option value="New">New</option>
              <option value="Visit">Visit</option>
            </select>
          </div>
        </div>

        <div className="input-employeecontainer">
          <div className="input-blockemployee">
            <label className="input-labelemployee">OPD Number</label>
            <Apointmentsearch onSearchChange={(v) => setSearchValue(v)} />
          </div>
          {isAuthorized && (
            <div className="input-blockemployee">
              <label htmlFor="hospitalcode" className="input-labelemployee">
                Hospital Code
              </label>
              <HospitalCodeSearch
                onSearchItem={(item) =>
                  setValues((v) => ({ ...v, hospitalcode: item.hospitalcode }))
                }
              />
            </div>
          )}
        </div>

        {/* ── Live summary cards shown after fetching ── */}
        {dataSupply.length > 0 && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "12px",
              margin: "16px 0",
            }}
          >
            {[
              {
                label: "Total Appointments",
                value: dataSupply.length,
                color: "#1e3a8a",
                bg: "#eff6ff",
                border: "#bfdbfe",
              },
              {
                label: "New Patients",
                value: `${newCount} (${formatINR(newRevenue)})`,
                color: "#1e3a8a",
                bg: "#eff6ff",
                border: "#bfdbfe",
              },
              {
                label: "Follow-up Visits",
                value: `${visitCount} (${formatINR(visitRevenue)})`,
                color: "#4c1d95",
                bg: "#f5f3ff",
                border: "#ddd6fe",
              },
              {
                label: "Total OPD Collection",
                value: formatINR(totalRevenue),
                color: "#065f46",
                bg: "#f0fdf4",
                border: "#bbf7d0",
              },
            ].map((card, i) => (
              <div
                key={i}
                style={{
                  background: card.bg,
                  border: `1px solid ${card.border}`,
                  borderRadius: "8px",
                  padding: "14px 16px",
                }}
              >
                <div
                  style={{
                    fontSize: "11px",
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    marginBottom: "6px",
                  }}
                >
                  {card.label}
                </div>
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: 600,
                    color: card.color,
                  }}
                >
                  {card.value}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="buttonDisplay">
          <button type="submit" className="allbuttonget">
            Get Details
          </button>
          <FaFileDownload
            className="download"
            onClick={handleDownload}
            title="Download professional report"
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="container2">
          <table id="supplyitem">
            <thead>
              <tr>
                <th>OPD Number</th>
                <th>Patient ID</th>
                <th>OPD Type</th>
                <th>Full Name</th>
                <th>Mobile No</th>
                <th>Appointment Time</th>
                <th>Created On</th>
                <th>Doctor</th>
                <th>Doctor Fees</th>
                {isAuthorized && <th>Hospital Code</th>}
              </tr>
            </thead>
            <tbody>
              {dataSupply.map((row, i) => (
                <tr key={i}>
                  <td>{row.opdnumber}</td>
                  <td>{row.patientid}</td>
                  <td>{row.opdtype}</td>
                  <td>{row.patientname}</td>
                  <td>{row.phoneno}</td>
                  <td>{row.appointmentdate}</td>
                  <td>{row.createdon}</td>
                  <td>{row.fname}</td>
                  <td>{formatINR(row.doctorfees)}</td>
                  {isAuthorized && <td>{row.hospitalcode}</td>}
                </tr>
              ))}
            </tbody>
            {dataSupply.length > 0 && (
              <tfoot>
                <tr>
                  <td
                    colSpan={isAuthorized ? 8 : 8}
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      padding: "10px",
                    }}
                  >
                    Total OPD Collection:
                  </td>
                  <td
                    style={{
                      fontWeight: 700,
                      color: "#065f46",
                      padding: "10px",
                    }}
                  >
                    {formatINR(totalRevenue)}
                  </td>
                  {isAuthorized && <td />}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </form>
    </div>
  );
};

export default AppointmentReport;
